export default __webpack_public_path__ + "static/media/TimeTable.f5b776fc.jpg";